import { useEffect } from 'react';
import { getCurrentBrand, applyBrandColors, applyBrandFavicon } from '@/lib/brand';

interface BrandProviderProps {
  children: React.ReactNode;
}

export function BrandProvider({ children }: BrandProviderProps) {
  useEffect(() => {
    // Apply brand colors on mount and when hostname changes
    const brand = getCurrentBrand();
    applyBrandColors(brand);
    applyBrandFavicon(brand);
    
    // Apply brand-specific CSS class to body
    if (typeof document !== 'undefined') {
      // Remove any existing brand classes
      document.body.classList.remove('brand-moyotools', 'brand-gerty', 'brand-thaton-realty');
      
      // Add the current brand class
      const brandKey = brand.name.toLowerCase().replace(/\s+/g, '-');
      document.body.classList.add(`brand-${brandKey}`);
      
      // Update document title and meta tags
      document.title = brand.name;
      
      // Update meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', brand.description);
      }
      
      // Update Open Graph tags
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', brand.name);
      }
      
      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', brand.description);
      }
      
      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) {
        ogUrl.setAttribute('content', `https://${brand.domain}`);
      }
      
      // Update Twitter card tags
      const twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.setAttribute('content', brand.name);
      }
      
      const twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.setAttribute('content', brand.description);
      }
    }
  }, []);

  return <>{children}</>;
} 